// Redux Term action types

export const FETCH_TERMS_FAILURE = 'FETCH_TERMS_FAILURE';
export const SELECT_TERM = 'SELECT_TERM';